<template>
    <div>
        <div>
            <section class="toolbar">
                <div class="toolbar-container">
                    <router-link id="back-button-cyclerules" v-bind:to="'/operator/home-page'"><img src="/static/images/back.png"></router-link>
                    <h1>Add Company</h1>
                </div>
            </section>
        </div>

        <div class="clearfix"></div>
        <section class="tab-container half-width-menu">
            <div id="custom-tab">
                <ul class="nav nav-pills">
                    <li class="active">
                        <a id="list_company" href="#list_company_tab" data-toggle="tab">List Company</a>
                    </li>
                    <li>
                        <a id="add_company" href="#add_company_tab" data-toggle="tab">Add Company</a>
                    </li>
                </ul>
                <div class="tab-content clearfix">
                    <div class="tab-pane active" id="list_company_tab">
                        <div class="list-container">
                            <div v-if="companyListSize == 0" class="custom-no-assets">
                                No Company Added
                            </div>

                            <table class="table" v-else id="company_list">
                            <thead>
                              <tr>
                                <th>Company Name</th>
                                <th>DOT</th>
                                
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="val in companyList" :id="'company-'+val.id" v-bind:key="val.id">
                                <td>{{ val.name }}</td>
                                <td>{{ val.dot }}</td>
                               
                              </tr>
                             
                            </tbody>
                          </table>

                            
                        </div>
                    </div>
                    <div class="tab-pane" id="add_company_tab">
                        <div class="col-md-12">
                            <div class="widget-wrap">
                                <div class="tab-container col-md-12 custom-padding0">
                                    <form class="form-inline " id="add_company_form">
                                        <div class="group">
                                            <input type="text" id="name" name="name" v-model="name">
                                            <span class="highlight"></span>
                                            <span class="bar"></span>
                                            <label for="company_name">Company Name: <span class="error-star">*</span></label>
                                        </div>
                                        <div class="group">
                                            <input type="text" id="dot" name="dot" v-model="dot">
                                            <span class="highlight"></span>
                                            <span class="bar"></span>
                                            <label for="dot">DOT: <span class="error-star">*</span></label>
                                        </div>
                                        <div class="group">
                                            <input type="text" id="address" name="address" v-model="address">
                                            <span class="highlight"></span>
                                            <span class="bar"></span>
                                            <label for="address">Address:</label>
                                        </div>
                                        <button type="button" v-on:click="addCompany()" class="btn btn-primary custom-btn">Save</button>
                                        <!--<button id="update-profile" type="button" class="btn btn-primary" v-on:click="updateProfile()">Update</button>-->
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    data: () => ({
        name: "",
        dot: "",
        address: "",
        companyList: [],
        companyListSize: 0,
    }),
    mounted() {
        /*let editor = this.$refs.editor;
        this.iframe.style = {
            position: 'absolute',
            width: window.innerWidth,
            height: window.innerHeight,
            top: -editor.offsetTop + "px",
            left: -editor.offsetLeft + "px",
        }
        this.iframe.wrapperStyle = {
            overflow: 'hidden',
            height: editor.clientHeight + "px",
            width: editor.clientWidth + "px",
        }
        this.loaded = true;*/
        this.call();
    },
    methods: {
        call: function() {
            var self = this;
            self.$config.loading=true;
            $.ajax({
                url: self.$config.API + '/operator/company/companylist',
                type: "GET",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },timeout: 10000,
                success: function(data) {self.$config.loading=false;
                    if (data.status == "success") {
                        self.companyList = data.data.companies;
                        self.companyListSize =  self.companyList.length;
                    } else {
                        self.companyListSize = 0;
                        alert("There was an error getting company list.")
                    }
                },
                error: function(jqXHR, exception, textstatus) {self.$config.loading=false;
                    //if session expired
                   if(textstatus==="timeout") {
            alert("Request timeout");
        } else if (jqXHR.responseJSON.code == 401) {
                        self.$router.push(
                            "/v1/operator/login"
                        )
                    } else if (jqXHR.responseJSON.code == 400) {
                        alert(jqXHR.responseJSON.message);
                    }

                }
            });
        },
        addCompany: function() {
            var self = this;
            if (self.name == "" || self.dot == ""){
                alert("Mandatory fields like DOT and Company name must not be left blank!");
                return;
            }
            $(".form-actions .error").text("")
            $("form i").removeClass("error");

            var name = $('#name').val();
            var dot = $('#dot').val();
            if (name == "") {
                $(".form-actions .error").text("Name can not be empty")
                return;
            }
            /*if (dot == "") {
                $(".form-actions .error").text("Dot can not be empty")
                return;
            }*/
            var data = $("form").serialize()
            var self = this;
            self.$config.loading=true;
            $.ajax({
                url: self.$config.API + '/admin/company/add',
                type: "POST",
                data: data,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },timeout: 10000,
                success: function(data) {

                    if (data.message == "success") {
                        $("#add_company_form")[0].reset();
                        self.dot = "";
                        self.name = "";
                        self.address = "";
                        alert("Company has been added successfully.");
                        self.call();
                    } else {
                        $(".form-actions .error").text(data.message)
                    }

                }, error: function(data, textstatus) {
                    self.$config.loading=false;
                    alert("addition of company failed : "+textstatus);
                }
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/addcompany.vue